import { PanelMenu } from "primereact/panelmenu";

const MobileNavMenu = ({ panelMenuItems }) => (
  <nav className="py-2">
    <PanelMenu model={panelMenuItems} />
  </nav>
);

export default MobileNavMenu;
